import { Slide, toast } from 'react-toastify';

export function toastCall(type, toastBody, position, toastId) {
  if (type === 'info') {
    toast.info(toastBody, {
      position,
      toastId
    });
  } else if (type === 'success') {
    toast.success(toastBody, {
      position,
      toastId
    });
  } else if (type === 'warning') {
    toast.warn(toastBody, {
      position,
      toastId
    });
  } else if (type === 'danger') {
    toast.error(toastBody, {
      position,
      toastId
    });
  } else if (type === 'dark') {
    toast.dark(toastBody, {
      position,
      toastId
    });
  } else {
    toast(toastBody || 'Demo toast', {
      position,
      toastId
    });
  }
}

// toast config
export function toastConfig() {
  toast.configure({
    transition: Slide,
    autoClose: 3000,
    hideProgressBar: true,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true
  });
}
